<template>

  <div class="page workorder">
      <div class="gridheader">
        <div class="row wrapper">
          <div class="col-md-4 title">
            <div class="row">
              <div class="col-2 col-md-1">
                <a v-on:click="back"><img src="../assets/img/arrow-left-white.svg" alt=""></a>
              </div>
              <div class="col-10 col-md-11 namescol">
                <h1>{{patientdata.name}} {{patientdata.surname}}</h1>
                <span>{{$t('WORKORDER')}}: {{workorder.workOrderId}}</span>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-6 namescol">
                <span>{{$t('DOCTOR')}}</span>
                <a v-if="workorder.doctorName != null" v-on:click.prevent="startChatByUserId(workorder.ordinationUserId, workOrderId)"><img src="../assets/img/chat-name-icon.svg" alt="" /> {{workorder.doctorName}} {{workorder.doctorSurname}}</a>
                <a v-if="workorder.doctorName == null">{{workorder.dummyPartner}}</a>
              </div>
              <div class="col-6 namescol">
                <span>{{$t('TECHNICIAN')}}</span>
                <a v-if="workorder.tehnicianName != null" v-on:click.prevent="startChatByUserId(workorder.tehnicianUserId, workOrderId)"><img src="../assets/img/chat-name-icon.svg" alt="" /> {{workorder.tehnicianName}} {{workorder.technicianSurname}}</a>
                <a v-if="workorder.tehnicianName == null">{{workorder.dummyPartner}}</a>
              </div>
            </div>
          </div>
          <div class="col-md-4 action">
            <router-link :to="{ path: '/printworkorder/'+workOrderId}" class="btn btn-white d-none d-md-block"><img src="../assets/img/icon-print.svg" alt=""> {{ $t('PRINTWORKORDER')}}</router-link>
          </div>
        </div>
      </div>
      <div class="gridheader secondary d-md-none">
        <div class="row wrapper">
          <div class="col-6">
            <a href="#" v-on:click.prevent="toggleMobileTabs" class="tablink" v-bind:class="(mobileTab == 'protetic') ? 'active' : ''">{{$t('PROTETICLIST')}}</a>
          </div>
          <div class="col-6">
            <a href="#" v-on:click.prevent="toggleMobileTabs" class="tablink" v-bind:class="(mobileTab == 'info') ? 'active' : ''">{{$t('INFORMATIONS')}}</a>
          </div>
          <div class="col-md-4 action"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 first-col d-none d-md-block">
          <div class="header">
            <div class="row">
              <h2>{{$t('PROTETICLIST')}}</h2>
            </div>
            <div class="row">
              <div class="col-md-4">
                <a  v-on:click.prevent="category = 'fixed'" v-bind:class="(category == 'fixed') ? 'active' : ''">{{$t('FIXED')}}</a>
              </div>
              <div class="col-md-4">
                <a  v-on:click.prevent="category = 'mobile'" v-bind:class="(category == 'mobile') ? 'active' : ''">{{$t('MOBILE')}}</a>
              </div>
              <div class="col-md-4">
                <a  v-on:click.prevent="category = 'other'" v-bind:class="(category == 'other') ? 'active' : ''">{{$t('REST')}}</a>
              </div>
            </div>
          </div>
          <div class="list-container">
            <div class="implant-comp" v-if="category == 'fixed'">{{$t('IMPLANTCOMPONENTS')}} <b-form-checkbox v-model="implantchecked" class="grey">{{$t('SHOW')}}</b-form-checkbox></div>
            <ul>
              <li v-on:click="addProtetic(protetic)" v-for="protetic in filteredprotetics"><span class="col-md-8 title">{{protetic.name}}</span><span class="col-md-2 shortname-type" v-bind:style="'background-color: '+(protetic.color)+';'">{{protetic.shortname}}</span><span class="col-md-2 quantity">x{{protetic.num}}</span></li>
            </ul>
          </div>
        </div>
        <div class="col-lg-3 first-col d-md-none" v-if="showProtetics">
          <div class="header">
            <div class="row">
              <h2>{{$t('PROTETICLIST')}}</h2>
            </div>
          </div>
          <div class="list-container">
            <ul>
              <li v-for="protetic in selectedprotetics"><span class="col-md-8 title">{{protetic.name}}</span><span class="col-md-2 shortname-type" v-bind:style="'background-color: '+(protetic.color)+';'">{{protetic.shortname}}</span><span class="col-md-2 quantity">x{{protetic.num}}</span></li>
            </ul>
          </div>
        </div>
        <div class="col-lg-6 mainworkorderteeth d-none d-md-block">
          <div class="row tm100">
            <div class="col-md-12 center"><a v-on:click.prevent="selectAll([11, 12, 13, 14, 15, 16, 17, 18, 21, 22, 23, 24, 25, 26, 27, 28])"  class="btn btn-fourth">{{$t('SELECTALL')}}</a></div>
          </div>
          <div class="row">
            <div class="col-12 center">
              <img class="workorderteethimg" src="../assets/img/teeth.svg">
              <div class="workorderteeth">
                <div class="selectedteeth"><teeth v-on:teethclick="toogleTooth" v-on:separatorclick="toogleSeparators" v-bind:tooth="tooth" v-bind:separators="separators"></teeth></div>
                <span v-on:click.prevent="deleteToothProp(props)" class="bigname-type" v-for="props in toothprops.upper" v-bind:style="'background-color: '+props.color">{{props.name}}</span>
                <div class="upper">
                  <div class="left">
                    <div class="tooth"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[18]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[17]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[16]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth smaller"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[15]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth smaller"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[14]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth small"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[13]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[12]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[11]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                  </div>
                  <div class="right">
                    <div class="tooth"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[21]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[22]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth small"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[23]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth smaller"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[24]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth smaller"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[25]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[26]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[27]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[28]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                  </div>
                </div>
                <div class="middle"></div>
                <div class="lower">
                  <div class="left">
                    <div class="tooth"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[48]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[47]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[46]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth smaller"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[45]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth smaller"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[44]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth small"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[43]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth smallest"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[42]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth smallest"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[41]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                  </div>
                  <div class="right">
                    <div class="tooth smallest"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[31]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth smallest"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[32]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth small"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[33]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth smaller"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[34]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth smaller"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[35]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[36]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[37]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                    <div class="tooth"><span v-on:click.prevent="deleteToothProp(props)" class="shortname-type" v-for="props in toothprops[38]" v-bind:style="'background-color: '+props.color">{{props.shortname}}</span></div>
                  </div>
                </div>
                <span v-on:click.prevent="deleteToothProp(props)" class="bigname-type lower-type" v-for="props in toothprops.lower" v-bind:style="'background-color: '+props.color">{{props.name}}</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 center"><a v-on:click.prevent="selectAll([31, 32, 33, 34, 35, 36, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48])"  class="btn btn-fourth">{{$t('SELECTALL')}}</a></div>
          </div>
        </div>
        <div v-if="showInfo" class="col-lg-3 last-col enable-scroll">
          <div class="col-item" v-b-toggle.notice>{{$t('NOTICE')}} <span class="down"></span></div>
          <b-collapse accordion="right-accordion" v-bind:visible="workorder.notice != ''" id="notice">
            <textarea v-model="workorder.notice" name="notice" class="form-control secondary"></textarea>
          </b-collapse>
          <div class="col-item" v-b-toggle.tasks>{{$t('TASKS')}} <span class="down"></span> <a  class="flexright"><img v-on:click.stop="newTask" src="../assets/img/plus-circle.svg" alt=""></a></div>
          <b-collapse accordion="right-accordion" id="tasks" v-bind:visible="tasksvisible" class="tasks">
            <div>
              <ul>
                <li v-for="task in tasks">
                  <div v-bind:class="task.status">
                    <div>
                      <span class="user"><img v-if="task.userId != globals.userId" v-on:click.prevent="startChatByUserId(task.userId, workOrderId)" src="../assets/img/chat-name-icon-blue.svg" alt=""> {{task.name}} {{task.surname}} <img src="../assets/img/chat-user-flow-pointer.svg" alt="" /> {{task.toName}} {{task.toSurname}} <img v-if="task.toUserId != globals.userId" v-on:click.prevent="startChatByUserId(task.toUserId, workOrderId)" src="../assets/img/chat-name-icon-blue.svg" alt=""></span>
                      <span class="date">{{task.deadline}}</span>
                      <span v-if="task.status == 'finished'" class="finishedtask">({{$t('FINISHED')}})</span>
                    </div>
                    <div>
                      <img src="../assets/img/cell-edit.svg" alt="" v-on:click="editTask(task)">
                      <img src="../assets/img/x-circle.svg" alt="" v-on:click="deleteTask(task.workOrderTaskId)">
                    </div>
                  </div>
                  <div class="inner">
                    {{task.text}}
                  </div>
                </li>
              </ul>
            </div>
          </b-collapse>
          <div class="col-item" v-b-toggle.additionalexpenses>{{$t('ADDITIONALEXPENSES')}} <span class="down"></span> <a class="flexright"><img v-on:click.stop="newExpense" src="../assets/img/plus-circle.svg" alt=""></a></div>
          <b-collapse accordion="right-accordion" id="additionalexpenses" class="tasks">
            <div>
              <ul>
                <li v-for="expense in expenses">
                  <div>
                    <div>
                      {{$t('PRICE')}}
                    </div>
                    <div>
                      {{expense.price}} {{$t('KNABBRV')}}
                    </div>
                  </div>
                  <div class="inner">
                    {{expense.text}}
                  </div>
                </li>
              </ul>
            </div>
          </b-collapse>
          <div class="col-item" v-on:click="showPatientGallery">{{$t('GALLERY')}} <a class="flexright" ><img src="../assets/img/icon-gallery-small.svg" alt=""></a></div>
          <div class="col-item" v-b-toggle.talks>{{$t('TALKS')}} <span class="down"></span> <a class="flexright"><img v-b-modal.newchat src="../assets/img/plus-circle.svg" alt=""></a></div>
          <b-collapse accordion="right-accordion" id="talks" v-bind:visible="chatvisible" class="tasks">
            <div>
              <ul>
                <li v-for="talk in talks" :key="talk.workOrderTalkId" v-on:click.prevent="startChatByUserId((talk.toUserId == globals.userId ? talk.fromUserId : talk.toUserId), workOrderId)">
                  <div>
                    <div>
                      <span class="user"><img src="../assets/img/chat-name-icon-blue.svg" alt=""> {{talk.name}} {{talk.surname}} <img src="../assets/img/chat-user-flow-pointer.svg" alt="" /> {{talk.toName}} {{talk.toSurname}}</span>
                      <span class="date">{{returnTalkTime(talk.dateTime)}}</span>
                    </div>
                  </div>
                  <div class="inner">
                    {{talk.text}}
                  </div>
                </li>
              </ul>
            </div>
          </b-collapse>
          <div class="workorderstatus">
            <div class="col-md-12">
              <div class="form-group ">
                <label>{{ $t('COLOR')}}</label>
                <select name="color" v-model="workorder.color" class="form-control secondary">
                  <option v-for="color in colors.root" v-bind:value="color.colorValue">{{color.colorValue}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>{{ $t('WORKORDERSTATUS')}}</label>
                <a class="btn btn-primary" v-if="workorder.status == 'open'" v-on:click="closeWorkOrder">{{$t('CLOSEWORKORDER')}}</a>
                <a class="btn btn-red" v-if="workorder.status == 'closed'">{{$t('WORKORDERCLOSED')}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <patientsgallery v-bind:patientId="galleryPatientId"></patientsgallery>

      <b-modal centered size="lg" ref="newtask" id="newtask" v-bind:ok-title="$t('SAVE')" v-bind:cancel-title="$t('CANCEL')" v-on:ok="saveTask" v-bind:title="$t('NEWTASK')">
        <form method="get" action="">
          <div class="row">
            <div class="col-12">
              <div class="form-group" v-bind:class="(formTaskError.notice && formTaskError.notice.text) ? 'has-danger' :''">
                <label>{{ $t('TEXT')}}</label>
                <textarea class="form-control secondary" v-model="formTask.text"></textarea>
                <div v-if="formTaskError.notice && formTaskError.notice.text" class="form-control-feedback">{{formTaskError.notice.text}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <inputvalidation v-bind:label="$t('DATE')" :formerror="formTaskError" name="deadline"><datepicker v-model="formTask.deadlinedate" format="dd.MM.yyyy" :bootstrapStyling="true" v-bind:placeholder="$t('DATE')"></datepicker></inputvalidation>
            </div>
            <div class="col-md-6">
              <inputvalidation v-bind:label="$t('TIME')" :formerror="formTaskError" name="deadline"><timepicker v-model="formTask.deadlinetime" format="HH:mm" :minute-interval="15" v-bind:placeholder="$t('DEADLINE')"></timepicker></inputvalidation>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <inputvalidation v-bind:label="$t('TOUSER')" :formerror="formTaskError" name="toUserId">
                <autocompletesimple v-model="formTask.toUserId" v-on:query="getWorkOrderPossibleUsers" v-bind:data="possibleUsers.root" v-bind:placeholder="$t('TOUSER')" v-bind:valuekey="'userId'" v-bind:text="'nameSurname'"></autocompletesimple>
                <!-- b-form-select v-model="formTask.toUserId" :plain="true" v-bind:options="possibleUsers.root" value-field="userId" text-field="nameSurname" class="form-control secondary" v-bind:placeholder="$t('TOUSER')"></b-form-select -->
              </inputvalidation>
            </div>
          </div>
          <p class="bg-danger" v-if="formTaskError.error && typeof formTaskError.notice == 'string'">{{formTaskError.notice}}</p>
          <div class="clearfix"></div>
        </form>
      </b-modal>

      <b-modal centered size="lg" ref="newexpense" id="newexpense" v-bind:ok-title="$t('SAVE')" v-bind:cancel-title="$t('CANCEL')" v-on:ok="saveExpenses" v-bind:title="$t('NEWEXPENSE')">
        <form method="get" action="">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group" v-bind:class="(formExpenseError.notice && formExpenseError.notice.text) ? 'has-danger' :''">
                <label>{{ $t('TEXT')}}</label>
                <textarea class="form-control secondary" v-model="formExpense.text"></textarea>
                <div v-if="formExpenseError.notice && formExpenseError.notice.text" class="form-control-feedback">{{formExpenseError.notice.text}}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group" v-bind:class="(formExpenseError.notice && formExpenseError.notice.price) ? 'has-danger' :''">
                <label>{{ $t('PRICE')}}</label>
                <input type="text" class="form-control secondary" v-model="formExpense.price" v-bind:placeholder="$t('PRICE')">
                <div v-if="formExpenseError.notice && formExpenseError.notice.price" class="form-control-feedback">{{formExpenseError.notice.price}}</div>
              </div>
            </div>
          </div>
          <p class="bg-danger" v-if="formExpenseError.error && typeof formExpenseError.notice == 'string'">{{formExpenseError.notice}}</p>
          <div class="clearfix"></div>
        </form>
      </b-modal>

      <b-modal centered size="sm" ref="newchat" id="newchat" v-bind:ok-title="$t('STARTCHAT')" v-bind:cancel-title="$t('CANCEL')" v-on:ok="startChat" v-bind:title="$t('NEWCHAT')">
        <form method="get" action="">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label>{{ $t('SELECTUSER')}}</label>
                <b-form-select v-model="chatUserId" :plain="true" v-bind:options="possibleUsers.root" value-field="userId" text-field="nameSurname" class="form-control secondary" v-bind:placeholder="$t('SELECTUSER')"></b-form-select></inputvalidation>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </form>
      </b-modal>

    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import Vue from 'vue'
import PatientsGallery from '@/components/PatientsGallery.vue'
import Teeth from '@/components/Teeth.vue'
import usersApi from '@/api/users'
import patientsApi from '@/api/patients'
import workordersApi from '@/api/workorders'
import workorderstalksApi from '@/api/workordertalks'
import proteticsApi from '@/api/protetics'
import proteticColorsApi from '@/api/protetic_colors'
var moment  = require('moment');

export default {
  name: 'WorkOrder',
  components:
  {
    'patientsgallery': PatientsGallery,
    'teeth': Teeth
  },
  data: function()
  {
    return {
      workOrderId: false,
      chatUserId: false,
      patientdata: {},
      protetics: {},
      implantchecked: false,
      category: 'fixed',
      galleryPatientId: false,
      workorder: {},
      tasks: [],
      talks: [],
      possibleUsers: {},
      formTaskError: {},
      formTask: {
          id: '',
          text: '',
          toUserId: '',
          deadlinedate: '',
          deadlinetime: {HH: "10", mm: "00"}
      },
      expenses: [],
      formExpenseError: {},
      formExpense: {
          text: '',
          price: 0
      },
      tasksvisible: false,
      chatvisible: false,
      colors: {},
      selectedColor: false,
      mobileTab: 'protetic',
      toothprops: {},
      tooth:
      {
        18: false,
        17: false,
        16: false,
        15: false,
        14: false,
        13: false,
        12: false,
        11: false,

        28: false,
        27: false,
        26: false,
        25: false,
        24: false,
        23: false,
        22: false,
        21: false,

        48: false,
        47: false,
        46: false,
        45: false,
        44: false,
        43: false,
        42: false,
        41: false,

        38: false,
        37: false,
        36: false,
        35: false,
        34: false,
        33: false,
        32: false,
        31: false,
        upper: false,
        lower: false
      },
      separators:
      {
        18: false,
        17: false,
        16: false,
        15: false,
        14: false,
        13: false,
        12: false,
        11: false,

        28: false,
        27: false,
        26: false,
        25: false,
        24: false,
        23: false,
        22: false,
        21: false,

        48: false,
        47: false,
        46: false,
        45: false,
        44: false,
        43: false,
        42: false,
        41: false,

        38: false,
        37: false,
        36: false,
        35: false,
        34: false,
        33: false,
        32: false,
        31: false
      },
      upperSelected: false,
      lowerSelected: false,
      showProtetics: false,
      showInfo: false
    };
  },
  created: function()
  {
    var me = this;

    me.workOrderId = me.$route.params.workOrderId;

    me.chatvisible = false;
    me.tasksvisible = false;

    if(typeof me.$route.query.open != 'undefined' && me.$route.query.open == 'tasks')
    {
      me.tasksvisible = true;
    }

    if(typeof me.$route.query.open != 'undefined' && me.$route.query.open == 'chat')
    {
      me.chatvisible = true;
    }

    me.refreshProtetics();

    me.getWorkOrder();

    setInterval(function()
    {
      if(window.innerWidth >= 768) me.showProtetics = true;
      else if(me.mobileTab == 'protetic') me.showProtetics = true;
      else me.showProtetics = false;

      if(window.innerWidth >= 768) me.showInfo = true;
      else if(me.mobileTab == 'info') me.showInfo = true;
      else me.showInfo = false;
    }, 1000);
  },
  methods:
  {
    selectAll(what)
    {
      var me = this;

      var obj = me.upperSelected;

      me.tooth.upper = false;
      me.tooth.lower = false;

      if(what[0] == 31) obj = me.lowerSelected;

      if(!obj)
      {
        me.activateTeeth(what[0], what[7], what[8], what[15], true);
        if(me.category != 'fixed')
        {
          if(what[0] == 31) me.tooth.lower = true;
          else me.tooth.upper = true;
        }
      }
      else
      {
        me.deactivateTeeth(what[0], what[7], what[8], what[15], true);
      }

      if(what[0] == 31) me.lowerSelected = !me.lowerSelected;
      else me.upperSelected = !me.upperSelected;
    },
    getWorkOrder()
    {
      var me = this;

      workordersApi.getWorkOrders({workOrderId: me.workOrderId}, function(data)
      {
        if(data.error && data.error == true)
        {
          Vue.$notify.error(data.notice);
          return;
        }

        me.workorder = data.root[0];
        if(data.root[0].separators != '') me.separators = JSON.parse(data.root[0].separators);

        patientsApi.getPatient({id: me.workorder.patientId}, function(data)
        {
          if(data.error && data.error == true)
          {
            Vue.$notify.error(data.notice);
            return;
          }
          me.patientdata = data.root;
        });

        me.getTasks();
        me.getTalks();
        me.getExpenses();
        me.getProtetics();
        me.getWorkOrderPossibleUsers({});
        me.getProteticColors();
      });
    },
    getProteticColors()
    {
      var me = this;
      proteticColorsApi.getColors({}, function(data)
      {
        if(data.error && data.error == true)
        {
          Vue.$notify.error(data.notice);
          return;
        }

        me.colors = data;
      });
    },
    returnTalkTime(dateTime)
    {
      return moment(dateTime).format('DD.MM.YYYY. (HH:mm)')
    },
    startChat()
    {
      var me = this;
      this.$store.commit('setChatData', {chatUserId: me.chatUserId, workOrderId: me.workOrderId})
    },
    toogleTooth: function(tooths)
    {
      var me = this;
      me.tooth.upper = false;
      me.tooth.lower = false;
      if(me.category == 'fixed')
      {
        for(var i=0;i<tooths.length;i++)
        {
          me.activateTeeth(tooths[i], tooths[i]);
        }
      }
      else
      {
        var tooth = tooths[0];
        if(me.tooth[tooth] == false)
        {
          me.deactivateAllTeeth();
          if((tooth >= 11 && tooth <= 18) || (tooth >= 21 && tooth <= 28))
          {
            me.activateTeeth(11, 18, 21, 28);
            me.tooth.upper = true;
          }
          else if((tooth >= 31 && tooth <= 38) || (tooth >= 41 && tooth <= 48))
          {
            me.activateTeeth(31, 38, 41, 48);
            me.tooth.lower = true;
          }
        }
        else me.deactivateAllTeeth();
      }
    },
    toogleSeparators(separator)
    {
      var me = this;
      me.separators[separator[0]] = !me.separators[separator[0]];
      workordersApi.toogleSeparators({workOrderId: me.workOrderId, separators: JSON.stringify(me.separators)}, function(data)
      {
        if(data.error && data.error == true)
        {
          Vue.$notify.error(data.notice);
          return;
        }
        me.getWorkOrder();
      });
    },
    activateTeeth: function(start, end, secStart, secEnd, noDeact)
    {
      var me = this;

      if(typeof noDeact == 'undefined' || noDeact == false)
      {
        for(var i=start;i<=end;i++)
        {
          if(me.tooth[i] == true)
          {
            me.deactivateTeeth(start, end, secStart, secEnd);
            return;
          }
        }

        for(var i=secStart;i<=secEnd;i++)
        {
          if(me.tooth[i] == true)
          {
            me.deactivateTeeth(start, end, secStart, secEnd);
            return;
          }
        }
      }

      for(var i=start;i<=end;i++)
      {
        me.tooth[i] = true;
      }

      for(var i=secStart;i<=secEnd;i++)
      {
        me.tooth[i] = true;
      }
    },
    deactivateTeeth: function(start, end, secStart, secEnd)
    {
      var me = this;
      for(var i=start;i<=end;i++)
      {
        me.tooth[i] = false;
      }

      for(var i=secStart;i<=secEnd;i++)
      {
        me.tooth[i] = false;
      }
    },
    deactivateAllTeeth: function()
    {
      var me = this;
      for(var i=11;i<=48;i++)
      {
        me.tooth[i] = false;
      }
    },
    addProtetic: function(protetic)
    {
      var me = this;
      workordersApi.addProtetic({workOrderId: me.workOrderId, proteticId: protetic.proteticId, tooths: JSON.stringify(me.tooth)}, function(data)
      {
        if(data.error && data.error == true)
        {
          Vue.$notify.error(data.notice);
          return;
        }
        me.refreshProtetics();
      });
    },
    deleteToothProp: function(props)
    {
      var me = this;

      me.$store.commit('setModalAlert',
      {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function()
        {
          workordersApi.deleteProtetic({workOrderId: me.workOrderId, props: JSON.stringify(props)}, function(data)
          {
            if(data.error && data.error == true)
            {
              Vue.$notify.error(data.notice);
              return;
            }
            me.refreshProtetics();
          });
        }
      })
    },
    refreshProtetics: function()
    {
      var me = this;
      workordersApi.getProtetics({workOrderId: me.workOrderId}, function(data)
      {
        if(data.error && data.error == true)
        {
          Vue.$notify.error(data.notice);
          return;
        }

        me.toothprops = data.data;
      });
    },
    getProtetics: function()
    {
      var me = this;
      proteticsApi.getProtetics({workOrderId: me.workOrderId, active: 1}, function(data)
      {
        if(data.error && data.error == true)
        {
          Vue.$notify.error(data.notice);
          return;
        }
        me.protetics = data;
      });
    },
    getWorkOrderPossibleUsers: function(params)
    {
      var me = this;
      workordersApi.getWorkOrderPossibleUsers({...params, workOrderId: me.workOrderId}, function(data)
      {
        if(data.error && data.error == true)
        {
          Vue.$notify.error(data.notice);
          return;
        }
        me.possibleUsers = data;
      });
    },
    showPatientGallery: function()
    {
      var me = this;
      me.galleryPatientId = false;
      Vue.nextTick(function()
      {
        me.galleryPatientId = me.workorder.patientId;
      })
    },
    saveTask: function(bvEvt)
    {
      var me = this;

      bvEvt.preventDefault();

      me.formTask.workOrderId = me.workorder.workOrderId;
      var params = Object.assign({}, me.formTask);
      console.log(JSON.stringify(params.deadlinetime))
      params.deadlinedate = moment(params.deadlinedate).format('YYYY-MM-DD')
      params.deadlinetime = params.deadlinetime.HH+':'+params.deadlinetime.mm;

      workordersApi.saveTask(params, function(val)
      {
        if(val.error)
        {
          me.formTaskError = val;
        }
        else
        {
          me.formTask.text = '';
          me.$refs.newtask.hide()
          me.getTasks();
        }
      })
    },
    getTasks: function()
    {
      var me = this;
      workordersApi.getTasks({workOrderId: me.workorder.workOrderId}, function(data)
      {
        if(data.error && data.error == true)
        {
          me.$notify.error(data.notice);
          return;
        }
        me.tasks = data.root;
      });
    },
    getTalks: function()
    {
      var me = this;
      workorderstalksApi.selectAllWorkOrderChats({workOrderId: me.workorder.workOrderId}, function(data)
      {
        if(data.error && data.error == true)
        {
          me.$notify.error(data.notice);
          return;
        }
        me.talks = data.root;
      });
    },
    deleteTask: function(workOrderTaskId)
    {
      var me = this;

      me.$store.commit('setModalAlert',
      {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function()
        {
          workordersApi.deleteTask({id: workOrderTaskId}, function(data)
          {
            if(data.error && data.error == true) Vue.$notify.error(data.notice);
            else Vue.$notify.success(data.notice);
            me.getTasks();
          })
        }
      })
    },
    newTask: function()
    {
      var me = this;
      me.formTask = {
        id: '',
        text: '',
        toUserId: '',
        deadlinedate: '',
        deadlinetime: {HH: "10", mm: "00"}
      };
      me.$refs.newtask.show()
    },
    editTask: function(data)
    {
      var me = this;
      data = Object.assign({}, data, {});
      data.id = data.workOrderTaskId;
      data.deadlinedate = data.deadline;
      data.deadlinetime = {HH: moment(data.deadline).format('HH'), mm: moment(data.deadline).format('mm')};
      me.formTask = data;
      me.$refs.newtask.show()
    },
    newExpense: function()
    {
      var me = this;
      me.formExpense = {
        text: '',
        price: 0
      };
      me.$refs.newexpense.show()
    },
    saveExpenses: function(bvEvt)
    {
      var me = this;

      bvEvt.preventDefault();

      workordersApi.saveExpenses({workOrderId: me.workorder.workOrderId, text: me.formExpense.text, price: me.formExpense.price}, function(val)
      {
        if(val.error)
        {
          me.formExpenseError = val;
        }
        else
        {
          me.formExpense.text = '';
          me.$refs.newexpense.hide()
          me.getExpenses();
        }
      })
    },
    getExpenses: function()
    {
      var me = this;
      workordersApi.getExpenses({workOrderId: me.workorder.workOrderId}, function(data)
      {
        if(data.error && data.error == true)
        {
          Vue.$notify.error(data.notice);
          return;
        }
        me.expenses = data.root;
      });
    },
    deleteExpenses: function(workOrderExpenseId)
    {
      var me = this;

      me.$store.commit('setModalAlert',
      {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function()
        {
          workordersApi.deleteExpenses({id: workOrderTaskId}, function(data)
          {
            if(data.error && data.error == true) Vue.$notify.error(data.notice);
            else Vue.$notify.success(data.notice);
            me.getExpenses();
          })
        }
      })
    },
    closeWorkOrder()
    {
      var me = this;

      me.$store.commit('setModalAlert',
      {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function()
        {
          workordersApi.saveWorkOrder({id: me.workorder.workOrderId, status: 'closed'}, function(data)
          {
            if(data.error && data.error == true) Vue.$notify.error(data.notice);
            else me.workorder.status = 'closed';
          });
        }
      })
    },
    toggleMobileTabs()
    {
      var me = this;
      if(me.mobileTab == 'protetic') me.mobileTab = 'info';
      else me.mobileTab = 'protetic';
    }
  },
  watch:
  {
    'workorder.notice': function(val, oldVal)
    {
      var me = this;

      if(typeof oldVal == 'undefined') return;

      workordersApi.saveWorkOrder({id: me.workorder.workOrderId, notice: val}, function(data)
      {
        if(data.error && data.error == true) Vue.$notify.error(data.notice);
      });
    },
    'workorder.color': function(val, oldVal)
    {
      var me = this;

      if(typeof oldVal == 'undefined') return;

      workordersApi.saveWorkOrder({id: me.workorder.workOrderId, color: val}, function(data)
      {
        if(data.error && data.error == true) Vue.$notify.error(data.notice);
      });
    },
    category: function()
    {
      var me = this;
      me.deactivateAllTeeth();
    },
    tooth: function()
    {
      alert('xxxx')
    }
  },
  computed:
  {
    ...mapGetters([
      'globals'
    ]),
    filteredprotetics: function()
    {
      var me = this;

      var out = [],
        outone = [];
      if(me.protetics.root)
      {
        for(var i=0;i<me.protetics.root.length;i++)
        {
          var protetic = me.protetics.root[i];
          if(protetic.category == me.category)
          {
            if(me.category == 'fixed')
            {
              if(me.implantchecked == true && protetic.implant == true)
              {
                outone.push(protetic);
                continue;
              }
              else if(me.implantchecked == false && protetic.implant == true)
              {
                continue;
              }
            }
            out.push(protetic);
          }
        }
      }

      return [...outone, ...out];
    },
    selectedprotetics: function()
    {
      var me = this;

      var out = [];
      if(me.protetics.root)
      {
        for(var i=0;i<me.protetics.root.length;i++)
        {
          var protetic = me.protetics.root[i];
          if(protetic.num > 0) out.push(protetic);
        }
      }

      return out;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/WorkOrder.vue